"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    decreaseButtonTitle: String,
    dragHandleTitle: String,
    increaseButtonTitle: String,
    largeStep: Number,
    max: Number,
    min: Number,
    orientation: String,
    showButtons: Boolean,
    smallStep: Number,
    tickPlacement: String,
    tooltip: Object,
    value: String | Number,

    // Events
    change: Function,
    slide: Function
};